
import { CollapseTransition } from 'vue2-transitions'

export default {
  name: 'TheHeaderMobileMenu',
  components: { CollapseTransition },
  props: {
    displayMenu: {
      type: Boolean,
      required: true
    }
  }
}
